// Actions
import {
  SET_PHONE_TRACKING_DATA,
  SET_PHONE_TRACKING_LOADER,
  SET_PHONE_TRACKING_DETAIL_DATA,
  SET_PHONE_TRACKING_DETAIL_LOADER,
  SET_PHONE_TRACKING_HISTORY_DATA,
  SET_PHONE_TRACKING_HISTORY_LOADER,
  SET_PHONE_TRACKING_SMS_HISTORY_DATA,
  SET_PHONE_TRACKING_SMS_HISTORY_LOADER,
  SET_PHONE_TRACKING_LOOKUP_DATA,
  SET_PHONE_TRACKING_LOOKUP_LOADER,
  CREATE_PHONE_TRACKING_NUMBER,
  UPDATE_PHONE_TRACKING_NUMBER,
  RELEASE_PHONE_TRACKING_NUMBER,
  LOGOUT,
} from '../actions/action-types';

const initialState = {
  phoneTrackingNumbers: [],
  rowsCount: 0,
  to: null,
  from: null,
  lastPage: null,
  currentPage: null,
  perPage: 20,
  loading: false,
  
  // Single phone tracking number details
  phoneTrackingDetail: null,
  phoneTrackingDetailLoader: false,

  // Phone tracking call history
  phoneTrackingHistory: [],
  phoneTrackingHistoryCount: 0,
  phoneTrackingHistoryTo: null,
  phoneTrackingHistoryFrom: null,
  phoneTrackingHistoryLastPage: null,
  phoneTrackingHistoryCurrentPage: null,
  phoneTrackingHistoryPerPage: 20,
  phoneTrackingHistoryLoader: false,

  // Phone tracking SMS history
  phoneTrackingSmsHistory: [],
  phoneTrackingSmsHistoryCount: 0,
  phoneTrackingSmsHistoryTo: null,
  phoneTrackingSmsHistoryFrom: null,
  phoneTrackingSmsHistoryLastPage: null,
  phoneTrackingSmsHistoryCurrentPage: null,
  phoneTrackingSmsHistoryPerPage: 20,
  phoneTrackingSmsHistoryLoader: false,
  
  // Phone number lookup results
  phoneTrackingLookupData: [],
  phoneTrackingLookupLoader: false,
};

const phoneTrackingReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_PHONE_TRACKING_DATA:
      return {
        ...state,
        phoneTrackingNumbers: payload.rows,
        rowsCount: payload.count,
        to: payload.to,
        from: payload.from,
        lastPage: payload.lastPage,
        currentPage: payload.currentPage,
        perPage: payload.perPage,
        totalRecordsInDB: payload.totalRecordsInDB
      };
      
    case SET_PHONE_TRACKING_LOADER:
      return { ...state, loading: payload };
      
    case SET_PHONE_TRACKING_DETAIL_DATA:
      return { ...state, phoneTrackingDetail: payload };
      
    case SET_PHONE_TRACKING_DETAIL_LOADER:
      return { ...state, phoneTrackingDetailLoader: payload };
      
    case SET_PHONE_TRACKING_HISTORY_DATA:
      return {
        ...state,
        phoneTrackingHistory: payload.rows || [],
        phoneTrackingHistoryCount: payload.count || 0,
        phoneTrackingHistoryTo: payload.to || null,
        phoneTrackingHistoryFrom: payload.from || null,
        phoneTrackingHistoryLastPage: payload.lastPage || null,
        phoneTrackingHistoryCurrentPage: payload.currentPage || null,
        phoneTrackingHistoryPerPage: payload.perPage || 20,
      };

    case SET_PHONE_TRACKING_HISTORY_LOADER:
      return { ...state, phoneTrackingHistoryLoader: payload };

    case SET_PHONE_TRACKING_SMS_HISTORY_DATA:
      return {
        ...state,
        phoneTrackingSmsHistory: payload.rows || [],
        phoneTrackingSmsHistoryCount: payload.count || 0,
        phoneTrackingSmsHistoryTo: payload.to || null,
        phoneTrackingSmsHistoryFrom: payload.from || null,
        phoneTrackingSmsHistoryLastPage: payload.lastPage || null,
        phoneTrackingSmsHistoryCurrentPage: payload.currentPage || null,
        phoneTrackingSmsHistoryPerPage: payload.perPage || 20,
      };

    case SET_PHONE_TRACKING_SMS_HISTORY_LOADER:
      return { ...state, phoneTrackingSmsHistoryLoader: payload };

    case SET_PHONE_TRACKING_LOOKUP_DATA:
      return { ...state, phoneTrackingLookupData: payload };
      
    case SET_PHONE_TRACKING_LOOKUP_LOADER:
      return { ...state, phoneTrackingLookupLoader: payload };
      
    case CREATE_PHONE_TRACKING_NUMBER:
      return {
        ...state,
        phoneTrackingNumbers: [...state.phoneTrackingNumbers, payload],
        rowsCount: state.rowsCount + 1,
      };
      
    case UPDATE_PHONE_TRACKING_NUMBER:
      return {
        ...state,
        phoneTrackingNumbers: state.phoneTrackingNumbers.map((number) =>
          number.id === payload.id ? { ...number, ...payload } : number
        ),
        phoneTrackingDetail: state.phoneTrackingDetail?.id === payload.id 
          ? { ...state.phoneTrackingDetail, ...payload } 
          : state.phoneTrackingDetail,
      };
      
    case RELEASE_PHONE_TRACKING_NUMBER:
      return {
        ...state,
        phoneTrackingNumbers: state.phoneTrackingNumbers.filter(
          (number) => number.id !== payload.id
        ),
        rowsCount: state.rowsCount > 0 ? state.rowsCount - 1 : 0,
        phoneTrackingDetail: state.phoneTrackingDetail?.id === payload.id 
          ? null 
          : state.phoneTrackingDetail,
      };
      
    case LOGOUT:
      return initialState;
      
    default:
      return state;
  }
};

export { phoneTrackingReducers };
